export interface SearchT {
  type: string;
  organizationName: string;
  scenarioID: string;
  scenarioName: string;
  deviceProfileID: string;
  deviceProfileName: string;
  deviceID: string;
  deviceName: string;
  sourceID: string;
  sourceName: string;
  iPNetworkID: string;
  iPNetworkName: string;
  templateID: string;
  templateName: string;
  deviceAddressIPv4: string;
  deviceAddressIPv6: string;
  deviceConfigID: string;
}

export const LABEL_SCHC_TEMPLATE = 'SCHC Template';
export const LABEL_SOURCE = 'Source';
export const LABEL_DEVICE_PROFILE = 'Device Profile';
export const LABEL_DEVICE = 'Device';
export const LABEL_IP_NETWORK = 'IP Network';
export const LABEL_FLOW = 'Flow';

export const TypeToLabel: Record<string, string> = {
  Template: LABEL_SCHC_TEMPLATE,
  Source: LABEL_SOURCE,
  DeviceProfile: LABEL_DEVICE_PROFILE,
  Device: LABEL_DEVICE,
  IPNetwork: LABEL_IP_NETWORK,
  Scenario: LABEL_FLOW,
};
